export enum EPasswordReset {
  DEFAULT,
  CUSTOM,
}
